import { render, staticRenderFns } from "./read-shaded.vue?vue&type=template&id=ea85bd24&"
import script from "./read-shaded.vue?vue&type=script&lang=js&"
export * from "./read-shaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports